// removed by extract-text-webpack-plugin
module.exports = {"root":"_2MCN8_2M","slide-content":"PmQGp_Pm","text":"rf6d9_rf"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/ChristmasBanner/ChristmasBanner.css
// module id = 453
// module chunks = 0